export const UPVOTE = 'upvote';
export const DOWNVOTE = 'downvote';
